import React from 'react';
import { Sparkles } from 'lucide-react';
import { ptsFor } from '../utils/points';

const STARTERS = [
    { name: 'Take out trash', minutes: 5, difficulty: 1 },
    { name: 'Dishes', minutes: 15, difficulty: 2 },
    { name: 'Vacuum', minutes: 20, difficulty: 2 },
    { name: 'Clean bathroom', minutes: 30, difficulty: 3 },
];

// Names what's missing and gives exactly one thing to tap — a few starters
// so the first tap isn't a blank form.
const EmptyChores = ({ memberCount = 1, onPickStarter, onAddClick }) => (
    <div className="flex flex-col items-center text-center py-10 px-4">
        <div className="w-11 h-11 rounded-2xl border border-dashed border-white/20 flex items-center justify-center">
            <Sparkles size={16} className="text-mint" />
        </div>
        <h3 className="font-serif text-xl text-ink-fg mt-5 max-w-[280px]">
            {memberCount > 1 ? `${memberCount} of you, no chores on the list.` : 'No chores on the list yet.'}
        </h3>
        <p className="text-sm text-ink-fg/50 mt-2.5 max-w-[290px] leading-relaxed">
            Add the things you actually do. Points come from minutes × difficulty, so a five-minute task and a big weekly clean sit honestly next to each other.
        </p>
        <button
            onClick={onAddClick}
            className="mt-5 px-6 py-2.5 rounded-xl bg-mint text-ink-shell font-bold text-sm hover:brightness-95 transition-all active:scale-95"
        >
            Add your first chore
        </button>
        <p className="text-[10px] font-mono font-medium text-ink-fg/30 uppercase tracking-widest mt-7">Or start from</p>
        <div className="flex flex-wrap gap-2 justify-center mt-3">
            {STARTERS.map(s => (
                <button
                    key={s.name}
                    onClick={() => onPickStarter(s)}
                    className="flex items-center gap-1.5 px-3 py-2 rounded-xl bg-ink-card2 border border-white/10 hover:border-mint/30 hover:bg-mint/5 transition-colors"
                >
                    <span className="text-xs font-medium text-ink-fg/80">{s.name}</span>
                    <span className="text-[10px] font-mono text-ink-fg/35">+{ptsFor(s.minutes, s.difficulty)}</span>
                </button>
            ))}
        </div>
    </div>
);

export default EmptyChores;
